<template>
  <div>
    <Banner></Banner>
    <Case></Case>
    <Product></Product>
    <News></News>
    <Profile></Profile>
    <Partner></Partner>
  </div>
</template>

<script>
import Banner from "./Banner";
import Case from "./Case";
import Product from "./Product";
import News from "./News";
import Profile from "./Profile";
import Partner from "./Partner";

export default {
  name: "Index",
  components: { Banner, Case, Product, News, Profile, Partner },
};
</script>

<style lang="scss">
.caption {
  // width: 40%;
  padding-top: 60px;
  padding-bottom: 30px;
  text-align: center;

  > h1 {
    margin-bottom: 5px;
    font-weight: 500;
    font-size: 22px;
    text-align: center;
    color: #333333;
  }

  > .caption-sub {
    width: 35vw;
    padding: 0 10px;
    display: flex;
    align-items: center;
    color: #b3b3b3;
    opacity: 0.6;

    > span {
      padding: 0 10px;
      font-size: 15px;
    }

    > .flex {
      width: 40%;
      flex: 1;
      height: 1px;
      background: #b3b3b3;
      box-sizing: border-box;
    }
  }

  &.caption-white {
    > h1 {
      color: #ffffff;
    }
    > .caption-sub {
      > span {
        color: #ffffff;
      }

      > .flex {
        background: #ffffff;
      }
    }
  }
}
</style>